import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import Close from '@mui/icons-material/Close'
import { Button, IconButton } from '@mui/material'
import { getNextVisitDateDifference } from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/utils/nextVisitRosterCalendarUtils'

const DialogHeader = ({
  currentView,
  selectedDate,
  bookingDate,
  isBookingLoading,
  onBackToCalendar,
  onSkip,
  nextVisitHoldSlotOmissionReason,
  setNextVisitHoldSlotOmissionReason,
  holdSlotOmissionDialog,
}) => {

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          {currentView === 'confirmation' && (
            <IconButton onClick={onBackToCalendar} size="small">
              <ArrowBack />
            </IconButton>
          )}
          <div>
            <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
              {currentView === 'calendar' ? 'Hold Slot For Next Visit' : 'Confirm & Book'}
            </div>
            <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '4px' }}>
              {selectedDate?.format('dddd, MMMM D, YYYY')} (
              {getNextVisitDateDifference(selectedDate, bookingDate)})
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            color="emrPrimary"
            endIcon={<ArrowForward />}
            disabled={isBookingLoading}
            onClick={() => holdSlotOmissionDialog?.show()}
          >
            Skip
          </Button>
          <IconButton disabled={isBookingLoading} onClick={() => onSkip()}>
            <Close />
          </IconButton>
        </div>
      </div>
    </>
  )
}

export default DialogHeader
